/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLocationData
 */
export interface CreateLocationData {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationData
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationData
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationData
     */
    longitude?: number | null;
    /**
     * Whether this location is enabled for clocking events.
     * @type {boolean}
     * @memberof CreateLocationData
     */
    enableClockIn?: boolean;
    /**
     * Controls whether this location can be used for clocking events from the main Shiftie application.<br><small>**Note:** this is only used by our first party applications and is ignored for direct API requests.</small>
     * @type {boolean}
     * @memberof CreateLocationData
     */
    allowClockInFromPersonalDevices?: boolean;
    /**
     * Controls whether this location can be used for clocking events from a Clock-In Portal.<br><small>**Note:** this is only used by our first party applications and is ignored for direct API requests.</small>
     * @type {boolean}
     * @memberof CreateLocationData
     */
    allowClockInFromPortals?: boolean;
    /**
     * Controls the maximum distance in meters an employee must be from a given location's geolocation to record clocking events.<br><small>**Note:** this is only used by our first party applications and is ignored for direct API requests.</small>
     * @type {number}
     * @memberof CreateLocationData
     */
    clockInGeoFenceInMeters?: number | null;
    /**
     * Can an employee clock in outside of the radius?
     * @type {boolean}
     * @memberof CreateLocationData
     */
    allowClockInsOutsideOfRadius?: boolean | null;
}

/**
 * Check if a given object implements the CreateLocationData interface.
 */
export function instanceOfCreateLocationData(value: object): value is CreateLocationData {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateLocationDataFromJSON(json: any): CreateLocationData {
    return CreateLocationDataFromJSONTyped(json, false);
}

export function CreateLocationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'enableClockIn': json['enableClockIn'] == null ? undefined : json['enableClockIn'],
        'allowClockInFromPersonalDevices': json['allowClockInFromPersonalDevices'] == null ? undefined : json['allowClockInFromPersonalDevices'],
        'allowClockInFromPortals': json['allowClockInFromPortals'] == null ? undefined : json['allowClockInFromPortals'],
        'clockInGeoFenceInMeters': json['clockInGeoFenceInMeters'] == null ? undefined : json['clockInGeoFenceInMeters'],
        'allowClockInsOutsideOfRadius': json['allowClockInsOutsideOfRadius'] == null ? undefined : json['allowClockInsOutsideOfRadius'],
    };
}

  export function CreateLocationDataToJSON(json: any): CreateLocationData {
      return CreateLocationDataToJSONTyped(json, false);
  }

  export function CreateLocationDataToJSONTyped(value?: CreateLocationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'enableClockIn': value['enableClockIn'],
        'allowClockInFromPersonalDevices': value['allowClockInFromPersonalDevices'],
        'allowClockInFromPortals': value['allowClockInFromPortals'],
        'clockInGeoFenceInMeters': value['clockInGeoFenceInMeters'],
        'allowClockInsOutsideOfRadius': value['allowClockInsOutsideOfRadius'],
    };
}

